import { observer } from '@formily/react';
import { IAnyObject } from '@yimoka/shared';
import { BaseStore, getEntityStore, IAPIKey, IEntityConfig } from '@yimoka/store';
import React, { useEffect } from 'react';

import { useDeepMemo } from '../../hooks/deep-memo';
import { useEntityConfig } from '../../hooks/entity-config';

import { Entity, IEntityProps } from './base';

export const EntityOperation = observer((props: IEntityOpProps) => {
  const { config, store, scope, operation, entity, instanceKey, dispose, ...args } = props;
  const curConfig = useEntityConfig(config ?? entity?.config);

  const curStore = useDeepMemo(() => {
    if (store instanceof BaseStore) {
      return store;
    }
    if (entity && operation) {
      return entity.getOperation({ ...(store ?? {}), instanceKey, opType: operation });
    }
    return getEntityStore(store, operation, curConfig, true);
  }, [store, entity, instanceKey, operation, curConfig]);

  useEffect(() => {
    if (!dispose || !entity || store instanceof BaseStore || !operation) return;
    return () => {
      entity.disposeOperation(operation, instanceKey);
    };
  }, [dispose, entity, store, instanceKey, operation]);

  const useScope = useDeepMemo(() => ({ $entity: entity, $config: curConfig, ...scope }), [entity, curConfig, scope]);

  return <Entity {...args} scope={useScope} store={curStore} />;
});

export type IEntityOpProps<V extends object = IAnyObject, R extends object = IAnyObject> = Partial<IEntityProps<V, R>> & {
  config?: IEntityConfig<V>;
  operation?: IAPIKey;
}
